module.exports = __webpack_public_path__ + "img/1F1EF-1F1F4.d2dae1c7.svg";